import moment from 'moment';

export default {

    methods: {
        createBarData(arr_ty, arr_py, type){

            // _py = previous year, _ty = this year

            if(!this.checkFormat(arr_ty) || !this.checkFormat(arr_py)){
                return null;
            }

            let xvalues_ty = [], yvalues_ty = [], barcolors_ty = [], maxvalue_ty = 0;
            let yvalues_py = [], barcolors_py = [], maxvalue_py = 0, maxvalue = 0;

            for (let i = 0; i < arr_ty.length; i++) {
                if (i == 0) {
                    xvalues_ty.push("Today");
                } else {
                    xvalues_ty.push(moment(arr_ty[i].bookingdate).format("DD/MM")); // 23 Sep
                }
                yvalues_ty.push(arr_ty[i].nr_bookings)
                if (arr_ty[i].nr_bookings > maxvalue_ty) {
                    maxvalue_ty = arr_ty[i].nr_bookings;
                }
                if (i == 0) {
                    barcolors_ty.push("green"); // color of today this year
                } else {
                    barcolors_ty.push("limegreen"); // color of other days of this year
                }
            }

            for (let i = 0; i < arr_py.length; i++) {
                yvalues_py.push(arr_py[i].nr_bookings)
                if (arr_py[i].nr_bookings > maxvalue_py) {
                    maxvalue_py = arr_py[i].nr_bookings;
                }
                barcolors_py.push("lightblue"); // color of previous year
            }

            maxvalue = maxvalue_ty;
            if(maxvalue < maxvalue_py){
                maxvalue = maxvalue_py;
            }

            let datasets = [];
            var currentYear = new Date().getFullYear();
            var previousYear = currentYear - 1;
            
            // previous year 
            dataset_element = {
                "backgroundColor": barcolors_py,
                "hoverBackgroundColor": "rgba(0,0,255,0.3)",   
                "data": yvalues_py,
                "borderColor": "#006400",
                "hoverBorderColor": "rgba(0,0,255,1)",     
                "label": "Bookings " + previousYear,
                "borderWidth": 2,
            };
            datasets.push(dataset_element);
            
            // this year
            let dataset_element = {
                "backgroundColor": barcolors_ty,
                "hoverBackgroundColor": "rgba(34,139,34,0.3)",   
                "data": yvalues_ty,
                "borderColor": "#006400",
                "hoverBorderColor": "rgba(34,139,34,1)",     
                "label": "Bookings " + currentYear,
                "borderWidth": 2,
            };
            datasets.push(dataset_element);

            if (type === "bar") {
                xvalues_ty = xvalues_ty.reverse();
                yvalues_ty = yvalues_ty.reverse();
                barcolors_ty = barcolors_ty.reverse();
                yvalues_py = yvalues_py.reverse();
            }

            let xdata = {
                "labels": xvalues_ty,
                "datasets": datasets,
            };

            let xminmax = {
                "min": 0,
                "max": ((((maxvalue + 20) - maxvalue%20) / 20) * 20) + 20,
            };
            let xscales= {};
            if (type === 'horizontalBar') {
                xscales = {"x": xminmax};
            } else {
                xscales = {"y": xminmax};
            }

            let xtitle = {
                "display": false,
                "text": "Number of bookings",
            };
            
            // Helper function to get ordinal suffix
            const getOrdinalSuffix = (day) => {
                if (day > 3 && day < 21) return 'th';
                switch (day % 10) {
                    case 1: return 'st';
                    case 2: return 'nd';
                    case 3: return 'rd';
                    default: return 'th';
                }
            };

            let xlegend = {
                legend: {
                    display: true
                },
                tooltip: { 
                    enabled: true,
                    callbacks: {
                        title: function(context) {
                            const dataIndex = context[0].dataIndex;
                            const datasetIndex = context[0].datasetIndex;
                            
                            // Get the bookingdate from the appropriate array
                            let referencedate;
                            if (datasetIndex === 0) {
                                // Previous year data
                                referencedate = arr_py[type === 'bar' ? arr_py.length - 1 - dataIndex : dataIndex]?.referencedate;
                            } else {
                                // This year data
                                referencedate = arr_ty[type === 'bar' ? arr_ty.length - 1 - dataIndex : dataIndex]?.referencedate;
                            }
                            
                            if (referencedate) {
                                const date = moment(referencedate);
                                const dayName = date.format('dddd'); // Full day name e.g., Saturday
                                const monthName = date.format('MMMM'); // Full month name e.g., January
                                const dayNumber = date.date(); // Day number
                                const ordinal = getOrdinalSuffix(dayNumber);
                                const year = date.format('YYYY'); // Year in 4-digit format
                                
                                return `${dayName}, ${monthName} ${dayNumber}${ordinal}, ${year}`;
                            }
                            return '';
                        },
                        label: function() {
                            return ''; // Remove the default label with dataset name and value
                        }
                    }
                },            
                datalabels: {
                    color: '#FF00000', 
                    anchor: 'end',
                    align: 'top',
                    font: {
                        size: 10,
                        weight: 'bold'
                    },
                    formatter: function(value, context){
                        return context !== null ? value === 0 ? '' : ''+value : 'ERR';                         
                    }
                }   
            };

            let xoptions = {
                "plugins": xlegend,
                "title": xtitle,
                "responsive": true,
                "maintainAspectRatio": false,
                "lineTension": 1,
                "scales": xscales,
            };
             
            let chartData = {
                "type": type,
                "data": xdata,
                "options": xoptions,
            };

            return chartData;

        },                
        getMaxValue(v){
            if(v - (((v - v%20) / 20) * 20) <= 10)
                return (((v - v%20) / 20) * 20) + 20
            return ((((v + 20) - v%20) / 20) * 20) + 20
        },        
        checkFormat(arr) {
            if (!Array.isArray(arr)) {
                console.log("parameter is not an array");
                return false;
            }
            if (arr.length > 0) {
                if (!('nr_bookings' in arr[0] && 'bookingdate' in arr[0])) {
                    console.log("array elements have unknown composition");
                    return false;
                }
            }
            return true;
        }        
    }
}